export default __webpack_public_path__ + "static/media/icon-arrow-left-long.b4651fbd.svg";